export default {"src":"/_next/static/media/clock-unavailable.02e4fde5.svg","height":40,"width":40};